export default __webpack_public_path__ + "static/pay-banner-4-3d45d240a05238d6b2d31184a6d7c80b.jpeg";